import { STATE_PROP } from './util/constants';

export const selectReducer = (state) => state[STATE_PROP];

export const selectUserManagements = (state) =>
  selectReducer(state) ? selectReducer(state).get('users') : {};
